import React, { useState, useEffect } from 'react';
import { useGoogleLogin } from '@react-oauth/google';
import API from '../api';
import { useAuth } from '../AuthContext';

const SCOPES_GMAIL = [
  'https://www.googleapis.com/auth/gmail.send',
  'https://www.googleapis.com/auth/gmail.readonly',
  'https://www.googleapis.com/auth/calendar.events',
  'openid',
  'email',
  'profile',
].join(' ');

export default function ConectarGmailModal({ onClose }) {
  const { usuario, getToken } = useAuth();
  const [estado, setEstado]   = useState(null);
  const [cargando, setCargando] = useState(true);
  const [error, setError]     = useState('');
  const [conectando, setConectando] = useState(false);

  async function refrescarEstado() {
    try {
      const token = getToken();
      const r = await API.get('/auth/gmail-status', {
        headers: { Authorization: `Bearer ${token}` },
      });
      setEstado(r.data);
    } catch (e) {
      setError(e.message);
    } finally {
      setCargando(false);
    }
  }

  useEffect(() => { refrescarEstado(); }, []);  // eslint-disable-line

  const iniciarOAuth = useGoogleLogin({
    flow: 'auth-code',
    scope: SCOPES_GMAIL,
    onSuccess: async (resp) => {
      setConectando(true); setError('');
      try {
        await API.post('/auth/conectar-gmail', {
          code:  resp.code,
          email: usuario.email,
        });
        await refrescarEstado();
      } catch (e) {
        setError(e.response?.data?.detail || e.message);
      } finally {
        setConectando(false);
      }
    },
    onError: (e) => setError(`OAuth canceló o falló: ${JSON.stringify(e)}`),
  });

  async function desconectar() {
    if (!window.confirm('¿Desconectar tu Gmail de Gulliver CRM? Tendrás que volver a autorizar para enviar emails.')) return;
    try {
      const token = getToken();
      await API.post('/auth/desconectar-gmail', {}, {
        headers: { Authorization: `Bearer ${token}` },
      });
      await refrescarEstado();
    } catch (e) {
      setError(e.message);
    }
  }

  const overlay = {
    position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    zIndex: 1000, padding: 20,
  };
  const modal = {
    background: 'white', borderRadius: 16, width: '100%', maxWidth: 480,
    padding: '1.5rem 2rem', boxShadow: '0 20px 50px rgba(0,0,0,0.3)',
  };

  return (
    <div style={overlay} onClick={onClose}>
      <div style={modal} onClick={e => e.stopPropagation()}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.25rem' }}>
          <h2 style={{ fontSize: 20, fontWeight: 800, margin: 0 }}>📧 Conexión Gmail</h2>
          <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: 24, cursor: 'pointer', color: '#6c757d' }}>×</button>
        </div>

        <div style={{ fontSize: 13, color: '#6c757d', marginBottom: '1.25rem', lineHeight: 1.6 }}>
          Cada Jefe de Proyecto debe autorizar a Gulliver CRM para enviar correos desde <strong>su propia cuenta</strong> y leer las respuestas que llegan a esa cuenta.
        </div>

        <div style={{ background: '#f8f9fa', borderRadius: 12, padding: '1rem 1.2rem', marginBottom: '1rem' }}>
          <div style={{ fontSize: 11, color: '#6c757d', textTransform: 'uppercase', letterSpacing: '.5px', marginBottom: 4, fontWeight: 700 }}>
            Cuenta logueada
          </div>
          <div style={{ fontSize: 14, fontWeight: 700, color: '#1a1a2e' }}>{usuario?.nombre} {usuario?.apellido}</div>
          <div style={{ fontSize: 12, color: '#6c757d' }}>{usuario?.email}</div>
        </div>

        {cargando ? (
          <div style={{ textAlign: 'center', color: '#6c757d', fontSize: 13 }}>Verificando estado...</div>
        ) : estado?.conectado ? (
          <>
            <div style={{
              background: '#d1fae5', color: '#065f46', borderRadius: 12,
              padding: '1rem 1.2rem', marginBottom: '1rem', textAlign: 'center',
            }}>
              <div style={{ fontSize: 28 }}>✅</div>
              <div style={{ fontSize: 14, fontWeight: 700, marginTop: 4 }}>Gmail conectado</div>
              <div style={{ fontSize: 12, color: '#047857', marginTop: 4 }}>
                Los correos que envíes saldrán desde {usuario?.email} y las respuestas se leerán automáticamente.
              </div>
            </div>
            <button onClick={desconectar} style={{
              padding: '8px 16px', borderRadius: 8, border: '1px solid #dee2e6',
              background: 'white', color: '#991b1b', fontSize: 13, cursor: 'pointer', width: '100%',
            }}>Desconectar Gmail</button>
          </>
        ) : (
          <>
            <div style={{
              background: '#fff8e1', color: '#92400e', borderRadius: 12,
              padding: '1rem 1.2rem', marginBottom: '1rem',
            }}>
              <div style={{ fontSize: 14, fontWeight: 700, marginBottom: 4 }}>⚠️ Gmail no conectado</div>
              <div style={{ fontSize: 12 }}>
                Sin esta autorización, los correos saldrán desde la cuenta del administrador del sistema.
              </div>
            </div>
            <button onClick={iniciarOAuth} disabled={conectando} style={{
              width: '100%', padding: '12px', borderRadius: 8, border: 'none',
              background: conectando ? '#6c757d' : '#3a86ff', color: 'white',
              fontSize: 14, fontWeight: 700, cursor: conectando ? 'default' : 'pointer',
            }}>
              {conectando ? '⏳ Conectando...' : '🔐 Autorizar Gulliver CRM a usar mi Gmail'}
            </button>
          </>
        )}

        {error && (
          <div style={{
            marginTop: '1rem', padding: '0.75rem', borderRadius: 8,
            background: '#fee2e2', color: '#991b1b', fontSize: 13,
          }}>⚠️ {error}</div>
        )}
      </div>
    </div>
  );
}
